/** Main Redux store configuration file, combines all reducers (state slices) into a single store */
import { configureStore } from '@reduxjs/toolkit';

import loadingReducer from './loadingSlice';
import authReducer from '../features/auth/authSlice';
import chatReducer from './chatSlice';
import tutorialReducer from './tutorialSlice';
import chatModeReducer from './chatModeSlice';
import voiceModeReducer from './voiceModeSlice';

const store = configureStore({
  reducer: {
    loading: loadingReducer,
    auth: authReducer, // auth state
    chat: chatReducer, // chat state
    tutorial: tutorialReducer, // tutorial state
    chatMode: chatModeReducer, // chat mode state (Ask Chat vs RAG modes)
    voiceMode: voiceModeReducer, // voice mode state
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;